import { inject, Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptorFn,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ProgressBarService } from '../services/progress-bar.service';

export const JwtInterceptor: HttpInterceptorFn = (req, next) => {
  const progressBarService = inject(ProgressBarService);
  progressBarService.show();

  return next(req).pipe(
    finalize(() => {
      setTimeout(() => {
        progressBarService.hide();
      }, 1000)
    })
  );
};
